
<template>
  <section class="wish pt-3">
    <app-loading :isFull="true" v-if="isLoading"/>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <header class="text-right mb-4">
            <h1 class="font-20">لیست علاقه مندی ها</h1>
          </header>
        </div>
      </div>
      <div class="row">
        <div class="wrapper-form w-100" v-if="fvorite">
          <m-wish-list :items="fvorite"/>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import MWishList from "cp/dashboard-component/wish";

export default {
  name: "wish",
  components: {
    MWishList
  },
  data() {
    return {
      isLoading: true,
    };
  },
  computed: {
    fvorite() {
      return this.$store.state.dashboardaFvorite.fvoriteList;
    }
  },
  mounted() {
    this.getWish();
  },
  methods: {
    async getWish() {
      await this.$store.dispatch("dashboardaFvorite/getFvorite");
      this.isLoading = false;
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/pages/dashboard/wish.vue